import { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../ui/tabs";
import DashboardTab from "./DashboardTab";
import ProductListTab from "./ProductListTab";
import ProductDetailDrawer from "./ProductDetailDrawer";
import CategoryManagementTab from "./CategoryManagementTab";
import ChangeLogTab from "./ChangeLogTab";
import DataReviewTab from "./DataReviewTab";

export default function B2CProductsManagement() {
	const [activeTab, setActiveTab] = useState("dashboard");
	const [selectedProductId, setSelectedProductId] = useState<number | null>(null);
	const [drawerOpen, setDrawerOpen] = useState(false);
	const [quickFilter, setQuickFilter] = useState("");

	const openProductDetail = (productId: number) => {
		setSelectedProductId(productId);
		setDrawerOpen(true);
	};

	const navigateToProducts = (filter?: string) => {
		if (filter) setQuickFilter(filter);
		setActiveTab("products");
	};

	const navigateToTab = (tab: string) => {
		setActiveTab(tab);
	};

	return (
		<div className="min-h-screen bg-gray-50 dark:bg-gray-900 p-4">
			<Tabs value={activeTab} onValueChange={setActiveTab}>
				<TabsList className="mb-6 bg-white dark:bg-gray-800 border dark:border-gray-700">
					<TabsTrigger value="dashboard">Dashboard</TabsTrigger>
					<TabsTrigger value="products">Products</TabsTrigger>
					<TabsTrigger value="data-review">Data Review</TabsTrigger>
					<TabsTrigger value="categories">Categories & Tags</TabsTrigger>
					<TabsTrigger value="changelog">Change Log</TabsTrigger>
				</TabsList>

				<TabsContent value="dashboard">
					<DashboardTab
						onNavigateToProducts={navigateToProducts}
						onOpenProduct={openProductDetail}
						onNavigateToTab={navigateToTab}
					/>
				</TabsContent>

				<TabsContent value="products">
					<ProductListTab
						quickFilter={quickFilter}
						onClearQuickFilter={() => setQuickFilter("")}
						onOpenProduct={openProductDetail}
					/>
				</TabsContent>

				<TabsContent value="data-review">
					<DataReviewTab />
				</TabsContent>

				<TabsContent value="categories">
					<CategoryManagementTab />
				</TabsContent>

				<TabsContent value="changelog">
					<ChangeLogTab />
				</TabsContent>
			</Tabs>

			{selectedProductId && (
				<ProductDetailDrawer
					productId={selectedProductId}
					open={drawerOpen}
					onClose={() => {
						setDrawerOpen(false);
						setSelectedProductId(null);
					}}
				/>
			)}
		</div>
	);
}
